import React from 'react';

import Header from '../../../Layout/Header';
import FooterComponent from '../../../Layout/Footer';
import banner from '../../../Assets/Linkages/Collaborations-Banner.jpg';
import '../../../Styles/Linkages&Outreach.css';
import '../../../Styles/Collaborations.css';
import CollaborationSections from './CollaborationSections';

const CollaborationsPage = () => (
  <>
    <Header />
    <main className="collaborations-page">
      <section className="outreach-event-hero" aria-label="Collaborations">
        <img src={banner} alt="NCGSA collaborations" />
      </section>
      <section className="collaborations-introduction" aria-labelledby="collaborations-introduction-title">
        <div className="collaborations-introduction-inner">
          <p className="section-eyebrow">STRATEGIC PARTNERSHIPS · SHARED PROGRESS</p>
          <h1 id="collaborations-introduction-title">Introduction</h1>
          <div className="collaborations-title-line" aria-hidden="true" />
          <p>
            The National Center of GIS and Space Applications (NCGSA) is committed to advancing
            space science, technology and its applications through its strategic collaborations
            with leading national and international academic institutions, industry stakeholders,
            governmental bodies, and research organizations. As a key national hub, NCGSA actively
            contributes to the global discourse on space and geospatial technologies through its
            participation in conferences, seminars, webinars, forums and exhibitions. These
            collaborations are anchored in shared objectives, promoting knowledge exchange,
            strengthening local capacities, encouraging interdisciplinary research, and developing
            practical solutions to address pressing societal challenges.
          </p>
        </div>
      </section>
      <CollaborationSections />
    </main>
    <FooterComponent />
  </>
);

export default CollaborationsPage;
